import axios from 'axios'

// Loyalty Configuration APIs
export const fetchLoyaltyReferralConfig = async () => {
  const response = await axios.get('configurations', {
    params: {
      key: 'LOYALTY_REFERRAL',
      page: 1,
      limit: 100,
    },
  })

  const configurations = response?.data?.data?.data || []
  return configurations.find((config) => config.key === 'LOYALTY_REFERRAL') || null
}

export const updateLoyaltyReferralConfig = async ({ metadata }) => {
  const response = await axios.put('configurations/key/LOYALTY_REFERRAL/metadata', {
    metadata,
  })

  return response.data.data
}

// Loyalty Points APIs
export const getLoyaltyPointsList = async (params) => {
  const response = await axios.get('loyalty/admin/points', {
    params: {
      page: params.currentPage || 1,
      limit: params.pageSize || 20,
      userId: params.userId,
      status: params.status,
      source: params.source,
      startDate: params.startDate,
      endDate: params.endDate,
    },
  })

  return {
    result: response.data.data.data || [],
    total: response.data.data.total || 0,
    totalPages: response.data.data.totalPages || 0,
  }
}

export const getUserLoyaltyBalance = async (userId) => {
  const response = await axios.get(`loyalty/admin/user/${userId}/balance`)

  return response.data.data
}

export const getUserLoyaltyHistory = async (userId, params) => {
  const response = await axios.get(`loyalty/admin/user/${userId}/history`, {
    params: {
      page: params?.currentPage || 1,
      limit: params?.pageSize || 20,
      type: params?.type,
    },
  })

  const data = response.data.data
  return {
    result: data.transactions || [],
    total: data.total || 0,
    totalPages: data.totalPages || 0,
    page: data.page || 1,
    limit: data.limit || 20,
  }
}

export const getUserReferralHistory = async (userId, params) => {
  const response = await axios.get(`loyalty/admin/user/${userId}/referrals`, {
    params: {
      page: params?.currentPage || 1,
      limit: params?.pageSize || 20,
    },
  })

  const data = response.data.data
  return {
    result: data.data || [],
    total: data.total || 0,
    totalPages: data.totalPages || 0,
    page: data.page || 1,
    limit: data.limit || 20,
  }
}

export const awardLoyaltyPoints = async (data) => {
  const response = await axios.post('loyalty/admin/award', data)

  return response.data.data
}

export const adjustLoyaltyPoints = async (data) => {
  const response = await axios.post('loyalty/admin/adjust', data)

  return response.data.data
}

export const expireLoyaltyPoints = async (loyaltyPointId) => {
  const response = await axios.put(`loyalty/admin/points/${loyaltyPointId}/expire`)

  return response.data.data
}

// Referral APIs
export const getReferralTransactionsList = async (params) => {
  const response = await axios.get('loyalty/admin/referrals', {
    params: {
      page: params.currentPage || 1,
      limit: params.pageSize || 20,
      referrerId: params.referrerId,
      referredUserId: params.referredUserId,
      status: params.status,
      startDate: params.startDate,
      endDate: params.endDate,
    },
  })

  return {
    result: response.data.data.data || [],
    total: response.data.data.total || 0,
    totalPages: response.data.data.totalPages || 0,
  }
}

export const getReferralStats = async () => {
  const response = await axios.get('loyalty/admin/referrals/stats')

  return response.data.data
}

export const cancelReferralTransaction = async (transactionId) => {
  const response = await axios.put(`loyalty/admin/referrals/${transactionId}/cancel`)

  return response.data.data
}

// Loyalty Redeem History APIs
export const getRedeemHistoryList = async (params) => {
  const response = await axios.get('loyalty/admin/redeem-history', {
    params: {
      page: params.currentPage || 1,
      limit: params.pageSize || 20,
      userId: params.userId,
      orderId: params.orderId,
      startDate: params.startDate,
      endDate: params.endDate,
    },
  })

  return {
    result: response.data.data.data || [],
    total: response.data.data.total || 0,
    totalPages: response.data.data.totalPages || 0,
  }
}

export const exportLoyaltyPoints = async (params) => {
  const response = await axios.get('loyalty/admin/points/export', {
    params,
    responseType: 'blob',
  })

  return response.data
}

export const exportReferralTransactions = async (params) => {
  const response = await axios.get('loyalty/admin/referrals/export', {
    params,
    responseType: 'blob',
  })

  return response.data
}

export const updateUserLoyaltyStatus = async (userId, loyaltyEnabled) => {
  const response = await axios.patch(`users/${userId}/update-customer`, {
    loyaltyEnabled,
  })

  return response.data.data
}
